export default __webpack_public_path__ + "./images/bg.dc90a11c.png";